<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" ref="SetBtn"></buttonlist>
		<div style="margin-top: 2px">
			<el-button type="primary" size="mini" :disabled="!btn.onhand" @click="showdialog">{{$t('getapi[2395]')}}</el-button>
			<el-button type="primary" size="mini" :disabled="!btn.frozen" @click="frozen(0)">{{$t('getapi[2396]')}}</el-button>
			<el-button type="primary" size="mini" :disabled="!btn.unfrozen" @click="frozen(1)">{{$t('getapi[2397]')}}</el-button>
			<el-button type="primary" size="mini" @click="collsoPrint(0)">{{$t('getapi[940]')+'('+$t('getapi[12884]')+')'}}</el-button>
			<el-button type="primary" size="mini" @click="collsoPrint(1)">{{$t('getapi[940]')+'('+$t('getapi[12885]')+')'}}</el-button>
		</div>
		<!-- <el-tabs :tab-position="'top'" type="" style="margin-top: 5px">
			<el-tab-pane :label="$t('getapi[945]')" name="0"> -->
				<!-- <el-table
					:data="dataSet"
					v-loading="loading"
					:highlight-current-row="true"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					:height="tableHeight"
					header-row-class-name="headerclass"
					@selection-change="handleSelectionChange"
					style="width: 100%; margin-top:0px"
				>
					<el-table-column type="selection" v-if="true"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="mp_flag" :label="$t('getapi[2363]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[137]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Qty_on_hand" :label="$t('getapi[3101]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="MeasureUnit" :label="$t('getapi[888]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[1957]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cargo_Type" :label="$t('getapi[867]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cargo_Group" :label="$t('getapi[1108]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Assist_Qty_on_hand" :label="$t('getapi[2389]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_ASSIST_UNIT" :label="$t('getapi[130]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Part_status" :label="$t('getapi[552]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="commodity_type_NAME" :label="$t('getapi[120]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_stuff" :label="$t('getapi[126]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="receive_time" :label="$t('getapi[2100]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="ISSUE_TIME" :label="$t('getapi[2179]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cost_unit_price" :label="$t('getapi[2248]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="assign_qty" :label="$t('getapi[2184]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Expiry_Date" :label="$t('getapi[225]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="CusPart_ID" :label="$t('getapi[2390]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="CusPart_Name" :label="$t('getapi[2391]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="frozenman" :label="$t('getapi[2392]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="frozentype" :label="$t('getapi[2393]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="items" :label="$t('getapi[2394]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Consumption_Date" :label="$t('getapi[1512]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Ice_out_date" :label="$t('getapi[2397]')"></el-table-column>
				</el-table> -->
			<!-- </el-tab-pane> -->
		<wTable id="xpane-0"
				:data="dataSet"
				:loading="loading"
				:header="tableHeader"
				queryData="InvMaterialonhandViewInfo"
				:filter_language="['Part_status']"
				:filter_thousandth="['Qty_on_hand','cost_unit_price','assign_qty','Assist_Qty_on_hand']"
				@handleSelectionChange="handleSelectionChange" :option="tableOption"  @contextmenu.prevent.native="openMenu($event)"
				ref="singleTable"></wTable>
			<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="InvMaterialonhandViewInfo" ref="ser" @getser="serclick"></serce>
		<!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="$t('getapi[982]')" queryData="InvMaterialonhandViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>
	
		<!-- 详情页面 -->
		<!-- <purordermanage :isVisible="isVisible" ref="order" @getdetail="getdetail"></purordermanage> -->
		<!-- 选择时间 -->
		<el-dialog v-dialogDrag :title="$t('getapi[2395]')" :visible.sync="dialogVisible" width="30%">
			<span>{{$t('getapi[225]')}}</span>
			<el-date-picker v-model="selectObj.shelflife" popper-class="select-option" type="date" value-format="yyyy-MM-dd" :placeholder="$t('getapi[6428]')" size="mini"></el-date-picker>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{$t('getapi[3086]')}}</el-button>
				<el-button type="primary" @click="changeperiod">{{$t('getapi[1146]')}}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="showCollsoPrint" :title="$t('getapi[940]')+ '('+(printtype == 0?$t('getapi[12884]'):$t('getapi[12885]'))+')'" width="300px" :close-on-click-modal="false">
			<el-divider></el-divider>
			<div>
				<table>
					<tr>
						<td>{{$t('getapi[12749]')}}</td>
						<td>
							<el-select v-model="printerid" class="select" @change="changePrinter">
								<el-option v-for="item in printerArr" :key="item.id" :label="item.name"
										   :value="item.id"></el-option>
							</el-select>
						</td>
						<td><el-button type="primary" @click="editPrinter" size="mini">{{ $t('getapi[34]') }}</el-button></td>
					</tr>
					<tr>
						<td>{{$t('getapi[12868]')}}</td>
						<td>
							<el-input v-model="copies" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
						</td>
					</tr>
				</table>
			</div>
			<el-divider></el-divider>

			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="showCollsoPrint = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="mini" type="primary" @click="confirmCollsoPrint">{{$t('getapi[1146]')}}{{$t('getapi[940]')}}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="showPrinter" :title="$t('getapi[34]')" width="40%" :close-on-click-modal="false">
			<el-divider></el-divider>
			<div>
				<div>
					<el-button type="primary" size="mini" @click="addPrinter">{{
						$t('getapi[878]') }}
					</el-button>
				</div>
				<el-table
						:data="printerArr"
						:highlight-current-row="true"
						:height="300"
						header-row-class-name="headerclass"
						border
						size="mini"
						style="width: 100%; margin-top:2px"
				>
					<el-table-column show-overflow-tooltip prop="ip" :label="$t('getapi[12750]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="model" :label="$t('getapi[12751]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="name" :label="$t('getapi[12752]')"></el-table-column>
					<el-table-column fixed="right" :label="$t('getapi[6048]')" width="150">
						<template slot-scope="scope">
							<el-button @click.native.prevent="editPrinter_(scope)" type="text" size="small">{{
								$t('getapi[34]') }}
							</el-button>
							<el-popconfirm
									:confirmButtonText="$t('getapi[6109]')"
									:cancelButtonText="$t('getapi[6]')"
									icon="el-icon-info"
									iconColor="red"
									:title="$t('getapi[637]')"
									@onConfirm="delPrinter_(scope)"
							>
								<el-button slot="reference" type="text" size="small">{{ $t('getapi[40]')
									}}
								</el-button>
							</el-popconfirm>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-divider></el-divider>

			<span slot="footer" class="dialog-footer">
				<el-button  @click="showPrinter = false" size="mini">{{ $t('getapi[6]') }}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="showEditPrinter" :title="$t('getapi[34]')" width="40%" :close-on-click-modal="false">

			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
				<table>
					<tr>
						<td>{{$t('getapi[12750]')}}</td>
						<td><el-input v-model="printerDetail.ip" type="text" size="mini"></el-input></td>
						<td>{{$t('getapi[12751]')}}</td>
						<td><el-input v-model="printerDetail.model" type="text" size="mini"></el-input></td>
					</tr>
					<tr>
						<td>{{$t('getapi[12752]')}}</td>
						<td><el-input v-model="printerDetail.name" type="text" size="mini"></el-input></td>
					</tr>
				</table>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="showEditPrinter = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="mini" type="primary" @click="savePrinter">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'InvInfoView',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('InvInfoView'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
			selectIDList: [],
			selectObj: {
				part_code: '',
				part_version: '',
				exclusively_id: 0,
				shelflife: ''
			},
			btn: {
				//人工冻结
				frozen: false,
				//人工解冻
				unfrozen: false,
				//变更保质期
				onhand: false
			},
            scrollTop:0,
            showCollsoPrint:false,
            printerid:'',
            printtype:0,
            selectPrinterDetail:{
                id:'',
                ip:'',
                model:'',
                name:''
            },
            copies:1,//打印份数
            cargo:0,//0：不带货位1：带货位
            printerArr:[],
            showPrinter:false,
            showEditPrinter:false,
            printerDetail:{
                id:'',
                ip:'',
                model:'',
                name:''
            },
            printData:[],
            addoreditprint: 1,//1新增2编辑
		};
	},
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
		that.colsort();
        that.$nextTick(function () {
            that.$processdata.initForm()
        })
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('InvMaterialonhandViewInfo',0,PFileds=>{
			that.tableHeader = PFileds;
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[982]"),this.$t("getapi[15]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			let limits=1;
			that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 83, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			limits = that.$limits.OperationAuthorityView('plv2', 83, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				default:
					break;
			}
			if(limits==-1||limits==1)that.closeAllRightButton();
            else that.btnauthority();
		},
		btnauthority() {
			let that = this;
			if (that.$limits.authority('plv4', 362, 1) == 1) {
				that.btn.frozen = true;
				that.btn.unfrozen = true;
			} else {
				that.btn.frozen = false;
				that.btn.unfrozen = false;
			}
			if (that.$limits.authority('plv4', 40, 1) == 1) {
				that.btn.onhand = true;
			} else {
				that.btn.onhand = false;
			}
		},
		closeAllRightButton(){
			let that =this;
			that.btn.onhand = false;
			that.btn.unfrozen = false;
			that.btn.frozen = false;
		},
		changeperiod() {
			let that = this;
			that.$http.urlpost('/Inv/Manager/InvInfoUpdateShelflife', that.selectObj, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
					that.getView();
				}
				that.dialogVisible = false;
			});
		},
		showdialog() {
			let that = this;
			if (that.selectObj.exclusively_id == 0) {
				that.$message.warning(that.$t('getapi[8623]'));//请选择一项！
				return;
			}
			that.dialogVisible = true;
		},
		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = [];
			that.selectIDList=[];
			for (let i = 0; i < val.length; i++) {
				if (i == 0) {
					that.selectObj = {
						part_code: val[0].part_code,
						part_version: val[0].part_version,
						exclusively_id: val[0].Exclusively_Id,
						shelflife: val[0].Expiry_Date
					};
				}
				let param = {
					exclusively_id: val[i].Exclusively_Id
				};
				that.selectIDList.push(param);
			}
			console.log(that.selectIDData);
		},
		frozen(type) {
			let that = this;
			let ids = {
				List: that.selectIDList
			};
			if (type == 0) {
				//冻结
				that.$http.urlpost('/Inv/Manager/InvInfoManFrozen', ids, function(res) {
					if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
						that.getView();
					}
				});
			} else {
				//解冻
				that.$http.urlpost('/Inv/Manager/InvInfoManUnFrozen', ids, function(res) {
					if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
						that.getView();
					}
				});
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;			
			this.$http.savePageSize('InvInfoView',val);
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'InvMaterialonhandViewInfo');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost('/Inv/Manager/InvInfoView', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
                    that.$nextTick(function () {
                        that.$processdata.initForm(0)
                    })
				}
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = Common.methods.getDatetime()
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			/*let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndexs,
				Ids: '',
				Param: datac
			};
			that.$http.urlpost('/Inv/Manager/InvInfoExportExcel', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "InvMaterialonhandViewInfo",
                fromname: that.$t('getapi[982]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
		// 保存
		save() {
			let that = this;
			let parm = that.dataDetail;
			that.$http.urlpost('/Pur/Requisition/SaveData', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
			});
		},
		//
		editInfo1() {},
		editInfo2() {},
		editInfo3() {},
		//打印
        collsoPrint(type){
		    let that = this
			that.printtype = type
			let parm = {}
            that.$http.urlpost('/Print/GetPrinter', parm, function (res) {
                if (res.Success == 1) {
                    if(res.DataContent){
                        that.printerArr = res.DataContent
                        that.printerid = window.localStorage.getItem('printerid_inv') == undefined?'':parseInt(window.localStorage.getItem('printerid_inv'))
                        for(let i=0;i<that.printerArr.length;i++){
                            if(that.printerid == that.printerArr[i].id){
                                that.selectPrinterDetail = that.printerArr[i]
                                break
                            }
                        }
                    }
                    let datac = [];
                    for (let i = 0; i < that.queryData.length; i++) {
                        datac.push({
                            query_Condition: that.queryData[i].query_Condition,
                            query_field_type: that.queryData[i].Query_Field_Type,
                            query_field_name: that.queryData[i].Query_Field_Name,
                            query_sort: that.queryData[i].query_sort,
                            row_sign: that.queryData[i].row_sign
                        });
                    }
                    let parm1 = {
                        PageIndex: 1,
                        PageSize: 10000,
                        Ids:type,
                        Param: datac
                    };
                    that.$http.urlpost('/Print/MaterialOnhandPrint', parm1, function (res) {
                        if(res.Success == 1){
                            that.printData = res.DataContent
							that.copies = 1
                            that.showCollsoPrint = true
                        }
                    })
                }
            });
		},
        changePrinter(val){
            let that = this
            console.log(val)
            for(let i=0;i<that.printerArr.length;i++){
                if(val == that.printerArr[i].id){
                    that.selectPrinterDetail = that.printerArr[i]
                }
            }
        },
        getPrinterArr(){
            let that = this
            that.$http.urlpost('/Print/GetPrinter', {}, function (res) {
                if (res.Success == 1) {
                    that.printerArr = res.DataContent
                }
            });
        },
        confirmCollsoPrint(){
            let  that = this
            that.printerid = window.localStorage.setItem('printerid_inv', that.selectPrinterDetail.id)
            let RequestData = { 'user': that.user,'data':that.printData,'printer':that.selectPrinterDetail,'copies':that.copies,'type':that.printtype};
            $.ajax({
                url: that.selectPrinterDetail.ip,
                type: 'post',
                contentType: 'application/json',
                data: JSON.stringify(RequestData),
                success: function (res) {
                    that.showCollsoPrint = false
                },
                error: function (xhr, errorType, error) {

                }
            });
        },
        editPrinter(){
            let that = this
            that.showPrinter = true
        },
        addPrinter(){
            let that = this
            that.showEditPrinter = true
            that.addoreditprint = 1
            that.printerDetail = {
                id: '',
                ip: '',
                model: '',
                name: ''
            };
        },
        editPrinter_(row) {
            let that = this
            that.showEditPrinter = true;
            that.addoreditprint = 2
            that.printerDetail = {
                id: row.row.id,
                ip: row.row.ip,
                model: row.row.model,
                name: row.row.name
            };
        },
        delPrinter_(row){
            let that = this
            let parm = {
                id: row.row.id,
                ip: row.row.ip,
                model: row.row.model,
                name: row.row.name
            }
            that.$http.urlpost('/Print/DeletePrinter', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    that.$http.urlpost('/Print/GetPrinter', {}, function (res) {
                        if (res.Success == 1) {
                            that.printerArr = res.DataContent
                        }
                    });
                }
            });
        },
        savePrinter(){
            let that = this
            let parm = that.printerDetail
            if(that.addoreditprint == 1){
                that.$http.urlpost('/Print/InsertPrinter', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.showEditPrinter = false
                        that.getPrinterArr()
                    }
                });
            } else if(that.addoreditprint == 2){
                that.$http.urlpost('/Print/UpdatePrinter', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.showEditPrinter = false
                        that.getPrinterArr()
                    }
                });
            }
        },
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
